<template>
  <v-btn
    :color="color"
    :class="{ 'create-button--small': isMobile }"
    :to="path"
    exact
  >
    <span v-if="!isMobile">
      <template v-if="text">
        {{ text }}
      </template>
      <template v-else>
        {{ 'New ' + entity }}
      </template>
    </span>
    <v-icon v-else :color="iconColor">{{ icon || 'add' }}</v-icon>
  </v-btn>
</template>

<script>
export default {
  name: 'CreateButton',
  props: {
    text: {
      type: String,
      default: '',
    },
    entity: {
      type: String,
      default: 'button',
    },
    path: {},
    icon: String,
    color: {
      type: String,
      default: 'primary',
    },
    iconColor: {
      type: String,
      default: 'light',
    },
  },
};
</script>

<style>
.v-btn.create-button--small {
  min-width: 36px !important;
  padding: 0 8px !important;
}
</style>
